/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import Footer from "../../examples/Footer";
import { useState, useEffect } from "react";

// Data

import reportsLineChartData from "../../layouts/dashboard/data/reportsLineChartData";

// Dashboard components

import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import { MdOutlinePreview } from "react-icons/md";
import { FaEdit } from "react-icons/fa";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Close";
import { useMemo } from "react";
import { MdDelete } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import {
  GridRowModes,
  GridToolbarContainer,
  GridActionsCellItem,
  GridRowEditStopReasons,
} from "@mui/x-data-grid";
function BodyMGuide() {
  const [rowModesModel, setRowModesModel] = useState({});

  const navigate = useNavigate();
  const handleEditClick = (id) => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
  };

  const handleCancelClick = (id) => () => {
    setRowModesModel({
      ...rowModesModel,
      [id]: { mode: GridRowModes.View, ignoreModifications: true },
    });
  };
  const handleSaveClick = async (id, categoryData) => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });
  };

  const [bodyData, setBodyData] = useState([]);
  const fetchData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/bodyData/getBodyMeasurementGuide`
      );
      console.log("Full Response:", response);

      const bodyData = response?.data?.data?.bodyData || [];
      console.log(bodyData, "Body Data");
      setBodyData(bodyData);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
   
    fetchData();
  }, []);

  //-------------------------------------------DELETE-------------------------------------------------------//
  const deleteBodyDataImages = async (_id) => {
    console.log(_id, "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA");
    try {
      const isConfirmed = window.confirm("Are you sure you want to delete this item?");
      if (!isConfirmed) return;

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/bodyData/deleteBodyMeasurementGuide/${_id}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      fetchData();
      if (!response.ok) {
        throw new Error("Failed to delete data");
      }
      const data = await response.json();
      console.log("Body data images deleted successfully:", data);

      // Refresh the page after successful deletion
      // window.location.reload();
    } catch (error) {
      console.error("Error deleting body data images:", error.message);
    }
  };

  const handleDeleteButtonClick = (_id) => {
    deleteBodyDataImages(_id);
  };

  const bodyGuideDetails = {
    Title: "Foot",
    Key: "test_key",
    Heading: "How to measure foot:",
    Description:
      "On a piece of paper, draw the outline of the foot and use a ruler to measure the distance from the tip of the heel to the tip of the toe.",
    Image: "img.png",
    Status: "Active",
  };

  const rows = useMemo(
    () =>
      bodyData &&
      bodyData.map((data, index) => ({
        ...data,
        id: data._id,
      }))
  );

  const columns = [
    // { field: "_id", headerName: "ID", width: 90 },

    {
      field: "key",
      headerName: "Key",
      width: 150,
      editable: true,
    },

    {
      field: "title",
      headerName: "Title",
      width: 150,
      editable: true,
    },
    {
      field: "description",
      headerName: "Description",
      width: 150,
      editable: true,
    },
    // {
    //   field: "description",
    //   headerName: "Description",
    //   width: 150,
    //   editable: true,
    // },
    {
      field: "image",
      headerName: "Image",
      width: 150,
      renderCell: (params) => (
        <div>
          {params.row.image && params.row.image.length > 0 && (
            <img src={params.row.image[0]} alt="image" style={{ width: "100px", height: "auto" }} />
          )}
        </div>
      ),
    },
    // {
    //   field: "status",
    //   headerName: "Status",
    //   width: 150,
    //   editable: true,
    // },
    {
      field: "action",
      headerName: "Action",
      description: "This column has a value getter and is not sortable.",
      sortable: false,
      width: 180,
      renderCell: (param) => {
        return (
          <>
            <div style={{ display: "flex", gap: "6px" }}>
              {/* <Tooltip
                onClick={() => navigate("/view_details", { state: bodyGuideDetails })}
                title="view"
              >
                <IconButton>
                  <MdOutlinePreview style={{ cursor: "pointer" }} />
                </IconButton>
              </Tooltip> */}
              <Tooltip
                onClick={() =>
                  navigate(
                    `/edit-body-measurement/${param.row._id}`,
                    console.log({ state: { productId: param.row._id } }),
                    "AAAAAAAA"
                  )
                }
                title="Edit"
              >
                <IconButton>
                  <FaEdit style={{ cursor: "pointer" }} />
                </IconButton>
              </Tooltip>
              <Tooltip title="Delete">
                <IconButton onClick={() => handleDeleteButtonClick(param.row._id)}>
                  <MdDelete style={{ cursor: "pointer" }} />
                </IconButton>
              </Tooltip>
            </div>
          </>
        );
      },
      valueGetter: (params) => `${params.row.Name || ""} ${params.row.lastName || ""}`,
    },
    // {
    //   field: "actions",
    //   type: "actions",
    //   headerName: "Quick Edit",
    //   // width: 100,
    //   cellClassName: "actions",
    //   getActions: (params) => {
    //     const isInEditMode = rowModesModel[params.id]?.mode === GridRowModes.Edit;

    //     if (isInEditMode) {
    //       return [
    //         <GridActionsCellItem
    //           icon={<SaveIcon />}
    //           label="Save"
    //           sx={{
    //             color: "green",
    //           }}
    //           onClick={() => {
    //             const rowWithoutImage = Object.entries(params.row).reduce((acc, [key, value]) => {
    //               if (key !== "image") {
    //                 acc[key] = value;
    //               }
    //               return acc;
    //             }, {});
    //             console.log(rowWithoutImage);
    //             handleSaveClick(params.id, rowWithoutImage);
    //             // window.location.reload();
    //           }}
    //         />,
    //         <GridActionsCellItem
    //           icon={<CancelIcon />}
    //           label="Cancel"
    //           className="textPrimary"
    //           onClick={handleCancelClick(params.id)}
    //           color="inherit"
    //         />,
    //       ];
    //     }
    //     return [
    //       <GridActionsCellItem
    //         icon={<EditIcon className="text-blue-400" />}
    //         label="Edit"
    //         className="textPrimary"
    //         onClick={handleEditClick(params.id)}
    //         color="inherit"
    //       />,
    //     ];
    //   },
    //   valueGetter: (params) => `${params.row.Name || ""} ${params.row.lastName || ""}`,
    // },
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <Box sx={{ height: 595, width: "100%", background: "white" }}>
          <DataGrid
            rows={rows}
            columns={columns}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 5,
                },
              },
            }}
            rowModesModel={rowModesModel}
            pageSizeOptions={[10]}
            checkboxSelection
            disableRowSelectionOnClick
          />
        </Box>
      </MDBox>
      {/* <Footer /> */}
    </DashboardLayout>
  );
}

export default BodyMGuide;
